import React, { useRef, useState } from "react";
import axios from "axios";
import html2canvas from "html2canvas";
import { Modal, Button } from "react-bootstrap";
import fondoCarnet from "../Components/ui/CarneSocio/carne_socio.jpg";
import fondo2 from "../Components/ui/CarneSocio/carne_cooperador.jpg";
import fondo3 from "../Components/ui/CarneSocio/carne_juvenil.jpg";

function CarnetSocio({ socio, foto }) {
    const [showModal, setShowModal] = useState(false);
    const fotoSocio = foto || "Sin Foto";
    const rut = socio.rut;
    const carnetRef = useRef();
    const abrirModal = () => setShowModal(true);
    const cerrarModal = () => setShowModal(false);

    const descargarCarnet = async () => {
        if (!carnetRef.current) return;
        const canvas = await html2canvas(carnetRef.current);
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const link = document.createElement("a");
        link.download = `carnet_${socio.rut}.jpg`;
        link.href = imgData;
        link.click();
        try {
            await axios.post("https://socios.kolpingchile.cl/backend/api/carnets", {
                rut: socio.rut,
                imagen: imgData,
            });
            console.log("Carnet guardado en la base de datos ✅");
        } catch (error) {
            console.error("Error guardando carnet en DB:", error);
        }
        cerrarModal();
    };

    const rutConGuion = (rut) => {
        if (!rut) return "";

        // Quitar puntos y guion
        let rutLimpio = rut.replace(/\./g, "").replace(/-/g, "");

        // Separar cuerpo y dígito verificador
        const cuerpo = rutLimpio.slice(0, -1);
        const dv = rutLimpio.slice(-1);

        // Formatear con puntos cada 3 dígitos (de derecha a izquierda)
        let cuerpoFormateado = "";
        let contador = 0;

        for (let i = cuerpo.length - 1; i >= 0; i--) {
            cuerpoFormateado = cuerpo[i] + cuerpoFormateado;
            contador++;
            if (contador % 3 === 0 && i !== 0) {
                cuerpoFormateado = "." + cuerpoFormateado;
            }
        }

        return `${cuerpoFormateado}-${dv.toUpperCase()}`; // Retornar con guion y dv en mayúscula
    };
    const rutFormateado = rutConGuion(rut);

    const fondo = socio.tipo_socio === "COOPERADOR" ? `url(${fondo2})` : socio.tipo_socio === "ESTUDIANTE" ? `url(${fondo3})` : `url(${fondoCarnet})`;

    return (
        <div className="text-center">
            {/* Botón para abrir modal */}
            <Button variant="outline-warning" onClick={abrirModal}>
                VISTA PREVIA 

            </Button>

            {/* Modal de vista previa */}
            <Modal show={showModal} onHide={cerrarModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>VISTA PREVIA CARNÉ DE SOCIO</Modal.Title>
                </Modal.Header>
                <Modal.Body className="text-center">
                    <div
                        ref={carnetRef}
                        style={{
                            width: "500px",
                            height: "320px",
                            backgroundImage: fondo,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            position: "relative",
                            borderRadius: "12px",
                            overflow: "hidden",
                            margin: "0 auto",
                        }}
                    >
                        {/* Datos superpuestos */}
                        <div
                            style={{
                                position: "absolute",
                                top: socio.tipo_socio === "COOPERADOR" ? "148px" : "118px",
                                left: "165px",
                                right: 40,
                                color: "rgba(0, 0, 0, 0.91)",
                                fontWeight: "bold",
                                fontSize: "11px",
                                textAlign: "left",
                                lineHeight: socio.tipo_socio === "COOPERADOR" ? "0" : "0.5"
                            }}
                            
                        >
                            <p style={{ fontSize: "13px", lineHeight: "0.8", fontWeight: "bolder" }}><strong>{socio.nombre} {socio.apellido}</strong></p>
                            <p style={{ fontSize: "12px", lineHeight: "0" }}>RUT: {rutFormateado}</p>
                            <p style={{  }}>EMAIL: {socio.email}</p>
                            <p style={{  }}>DIRECCIÓN: {socio.direccion}</p>
                            <p style={{ lineHeight: "0.9" }}>COMUNA: {socio.comuna}, {socio.region}</p>
                            <p style={{  }}>OCUPACIÓN: {socio.oficio}</p>
                            <p style={{ fontSize: "12px", lineHeight: "0", fontStyle: "italic" }}>Oficializado el {socio.fecha_oficializacion}</p>
                        </div>
                        <div
                            style={{
                                position: "absolute",
                                top: 200,
                                left: 28,
                                color: "#000",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                lineHeight: "0.5"
                            }}><p>N° SOCIO: {socio.n_socio}</p></div>
                        <div
                            style={{
                                position: "absolute",
                                top: socio.tipo_socio === "COOPERADOR" ? 100 : 280,
                                left: socio.tipo_socio === "COOPERADOR" ? 300 : 250,
                                right: socio.tipo_socio === "COOPERADOR" ? 30 : 40,
                                color: "#000",
                                fontWeight: "bold",
                                fontSize: "14px",
                                textAlign: "left",
                                lineHeight: "1",
                                display: socio.tipo_socio === "COOPERADOR" ? "none" : "block"
                            }}><p>FAMILIA {socio.familia}</p></div>

                        {/* Foto socio */}
                        <div
                            style={{
                                position: "absolute",
                                top: 21,
                                left: 20,
                                width: 128,
                                height: 170,
                                overflow: "hidden",
                                border: "1px solid #ccc",
                            }}
                        >
                            <img
                                src={fotoSocio}
                                alt="Foto Socio"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover", // mantiene el recorte sin deformar
                                    objectPosition: "center",
                                }}
                            />
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={cerrarModal}>Cerrar</Button>
                    <Button variant="success" onClick={descargarCarnet}>Descargar JPG</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default CarnetSocio;
